import { api, currentCreche } from '../api'

const ClassroomRepository = {
    index (query = null, crecheUuid = null) {
        return api().$get(`/${crecheUuid || currentCreche().uuid}/classrooms`, query)
    },

    show (classroomUuid) {
        return api().$get(`/${currentCreche().uuid}/classrooms/${classroomUuid}`)
    },

    create (payload) {
        return api().$post(`/${currentCreche().uuid}/classrooms`, payload)
    },

    update (classroomUuid, payload) {
        return api().$put(`/${currentCreche().uuid}/classrooms/${classroomUuid}`, payload)
    },

    delete (classroomUuid) {
        return api().$delete(`/${currentCreche().uuid}/classrooms/${classroomUuid}`)
    },

    moveRegistrations (classroomUuid, payload) {
        return api().$post(`/${currentCreche().uuid}/classrooms/${classroomUuid}/move-registrations`, payload)
    },

    printContactTable (classroomUuid, query = {}) {
        return api().$get(`/${currentCreche().uuid}/documents/classroom/${classroomUuid}/contact-table-document`, query, { download: true })
    },

    printAutorizationsTable (classroomUuid, query = {}) {
        return api().$get(`/${currentCreche().uuid}/documents/classroom/${classroomUuid}/babies-autorizations-document`, query, { download: true })
    }
}

export default ClassroomRepository
